import React from "react";
import { Stack, Typography } from "@mui/material";
import { ExportDataTypeInclusionSelector } from "./ExportDataTypeInclusionSelector";
import { EXPORT_INCLUSION_TYPES, type ExportFieldConfiguration } from "./types";
import { getCommonExportRatioOptions } from "./utils";
import { FieldConfigurationSelector } from "./FieldConfigurationSelector";
import {
  generativeAIExportFields,
  firmographicsExportFields,
} from "./exportConfigurationFields";

const DATA_TYPE = "Gen AI Navigator";

interface Props {
  inclusion: EXPORT_INCLUSION_TYPES;
  setInclusion: (value: EXPORT_INCLUSION_TYPES) => void;
  fieldConfiguration: ExportFieldConfiguration;
  setFieldConfiguration: (cfg: ExportFieldConfiguration) => void;
  enforceMandatoryFields?: boolean;
}

export const GenAIExportOptions: React.FC<Props> = ({
  inclusion,
  setInclusion,
  fieldConfiguration,
  setFieldConfiguration,
  enforceMandatoryFields,
}) => {
  const isDisabled = inclusion === EXPORT_INCLUSION_TYPES.NONE;

  return (
    <Stack spacing={2} sx={{ width: "70%", paddingTop: "40px" }}>
      <Typography variant="h5" fontWeight={500} fontSize={16}>
        Gen AI Navigator
      </Typography>
      <ExportDataTypeInclusionSelector
        dataType={DATA_TYPE}
        options={getCommonExportRatioOptions(DATA_TYPE)}
        inclusion={inclusion}
        setInclusion={setInclusion}
      />
      <FieldConfigurationSelector
        fields={generativeAIExportFields}
        firmographicsFields={firmographicsExportFields}
        value={fieldConfiguration}
        onChange={setFieldConfiguration}
        title="Gen AI Navigator Fields"
        checkboxLabel="Export All Gen AI Navigator Fields"
        // Matches OppGen: company_group_id force-injection is only active
        // behind the universe_enforce_mandatory_fields_for_tracking flag.
        requiredField={
          enforceMandatoryFields ? { values: ["company_group_id"] } : undefined
        }
        disabled={isDisabled}
      />
    </Stack>
  );
};
